import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
// import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import {
  maskPhone,
  documentNumberFormatter,
  dateFormatter,
  maskRemove,
  isValidEmail,
  isValidCpf,
  isValidCnpj,
} from "../../services/UtilsService";
import {
  Avatar,
  Grid,
  InputAdornment,
  MenuItem,
  Pagination,
  Select,
  // Tooltip,
} from "@mui/material";
import {
  // Assessment,
  PersonOutline,
  Storefront,
} from "@mui/icons-material";
import { DelendButton } from "../Buttons";
import CustomerService from "../../services/CustomerService";
import OpenFinanceSummarizedInformationTab from "../../pages/Dashboard/Consent/OpenFinanceSummarizedInformationTab";
import DelendLocalCentralizedCircularProgress from "../CircularProgress/DelendLocalCentralizedCircularProgress";

const DelendPaginator = (props) => {
  const [rows, setRow] = React.useState(props.rows);
  const [searchText, setSearchText] = React.useState(null);
  const [searchParameter, setSearchParameter] = React.useState(null);
  const [pageQuantity, setPageQuantity] = React.useState(0); 
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [page, setPage] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [person, setPerson] = React.useState(null);

  // let navigate = useNavigate();

  React.useEffect(() => {
    const fetchCustomerList = async () => {
      setLoading(true);
      const response = await CustomerService.listCustomer(rowsPerPage, page, searchParameter);
      if (response.customers) {
        setRow(response.customers);
      }
      if (response.pages) {
        setPageQuantity(response.pages)
      }
      if (response.pages === 0) {
        setPageQuantity(1)
      }
      setLoading(false);
    };

    if (props.open === false) fetchCustomerList();
  }, [rowsPerPage, props.open, page, searchParameter]);

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const isLegalPerson = (documentNumber) => {
    return documentNumber.length > 11;
  };

  const filterRows = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchClick = () => {
    let searchField = "";
    let text = searchText;
    if (isValidEmail(text)) {
      searchField = "email";
    } else if (
      text &&
      (isValidCpf(maskRemove(text)) || isValidCnpj(maskRemove(text)))
    ) {
      searchField = "documentNumber";
      text = maskRemove(text);
    } else if (text) searchField = "mobilePhone";

    const search = searchField ? searchField + "=" + text : null;
    setSearchParameter(search)
  };

  const handleDrawerOpen = (person) => {
    setOpen(true);
    setPerson(person);
  };

  const handleDrawerClose = (needRefresh) => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Grid container justifyContent="flex-end">
        <DelendButton text={"Solicitar Open Finance"} onClick={props.onClick} />
      </Grid>
      <Paper
        variant="outlined"
        sx={{ padding: 0, borderRadius: "8px", marginTop: "32px" }}
      >
        <Box sx={{ padding: 0 }}>
          <Grid container>
            <Grid
              sx={{
                height: 80,
                borderBottom: "1px solid #E9EBF0",
                paddingTop: "15px",
              }}
              item
              xs={12}
            >
              <TextField
                style={{ width: 350, height: 40, marginLeft: 40 }}
                InputProps={{
                  sx: { fontSize: 12, borderRadius: 50, paddingLeft: "12px" },
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        onClick={handleSearchClick}
                        sx={{ color: "#8A99A5", cursor: "pointer" }}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder="Procure por documento, telefone ou e-mail"
                onChange={filterRows}
              />
            </Grid>
          </Grid>
          <TableContainer>
            <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
              <TableBody>
                <TableRow
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  <TableCell sx={{ width: "50px" }} />
                  <TableCell
                    sx={{ borderRight: "1px solid #E9EBF0", width: 340 }}
                  >
                    Nome • Número documento
                  </TableCell>
                  <TableCell
                    sx={{ width: 300, borderRight: "1px solid #E9EBF0" }}
                    align="'inherit'"
                  >
                     Número de Celular
                  </TableCell>
                  <TableCell
                    sx={{ width: 300, borderRight: "1px solid #E9EBF0" }}
                    align="'inherit'"
                  >
                     E-mail      
                  </TableCell>
                  <TableCell
                    sx={{
                      display: "flex",
                      flex: 1,
                      borderRight: "1px solid #E9EBF0",
                    }}
                    align="'inherit'"
                  >
                    Data de cadastro
                  </TableCell>
                  <TableCell sx={{ width: "50px" }}></TableCell>
                </TableRow>
                {
                loading ? <DelendLocalCentralizedCircularProgress/> :
                (rows ? rows : []).map((row, index) => (
                  <TableRow
                    hover
                    onClick={() => handleDrawerOpen(row)}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      cursor: "pointer",
                    }}
                    key={row.personUuid}
                  >
                    <TableCell
                      sx={{ width: "50px", opacity: "0.58", marginTop: "-3px" }}
                    >
                      {isLegalPerson(row.documentNumber) ? (
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            backgroundColor: "#FFF",
                            border: "1px solid #820AD1",
                            borderStyle: "dashed",
                            marginTop: "7px",
                          }}
                        >
                          <Storefront sx={{ color: "#820AD1" }} />
                        </Avatar>
                      ) : (
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            backgroundColor: "#FFF",
                            border: "1px solid #503DFC",
                            borderStyle: "dashed",
                            marginTop: "7px",
                          }}
                        >
                          <PersonOutline sx={{ color: "#503DFC" }} />
                        </Avatar>
                      )}
                    </TableCell>
                    <TableCell sx={{ width: 340 }}>
                      {row.name ? row.name : "Nome não informado"} <br />
                      <span style={{ fontSize: 12, color: "#8087A6" }}>
                        {documentNumberFormatter(row.documentNumber)}
                      </span>
                    </TableCell>
                    <TableCell
                      sx={{ width: 300, wordWrap: "break-word" }}
                      align="left"
                    >
                      {row.mobilePhone
                        ? maskPhone(row.mobilePhone)
                        : "Celular não informado"}{" "}
                      <br />
                    </TableCell>
                    <TableCell  sx={{ width: 300, wordWrap: "break-word" }}>
                    {row.email ? row.email : "E-mail não informado"}
                    </TableCell>
                    <TableCell
                      sx={{ display: "flex", flex: 1, flexDirection: "column" }}
                      align="left"
                    >
                      {dateFormatter(row.createdAt)}
                      <span style={{ fontSize: 12, color: "#8087A6" }}>
                        {row.createdBy ? "por " + row.createdBy.name : ""}
                      </span>
                    </TableCell>
                    {/* <TableCell
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/dashboard/view/customer/dashboard/${row.personUuid}`);
                      }}
                      sx={{
                        "&:hover": { color: "#1976d2", opacity: 1 },
                        width: "50px",
                        opacity: "0.58",
                        marginTop: "-2px",
                      }}
                    >
                      <Tooltip title="Acessar o Open Finance">
                        <Assessment />
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow align="right">
                  <Grid container justifyContent="flex-end">
                    <Grid>
                    Itens por página
                    <Select
                      sx={{
                        boxShadow: "none",
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      }}
                      value={rowsPerPage}
                      label="RowsPerPage"
                      onChange={handleChangeRowsPerPage}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                    </Select>
                    </Grid>
                    <Grid>
                    <Pagination  sx={{paddingTop: '12px'}} rowsPerPageOptions={[]}  disabled={loading} count={pageQuantity} onChange={(event, page) => setPage(page)} />
                    </Grid>
                  </Grid>
                  </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <OpenFinanceSummarizedInformationTab
            open={open}
            handleDrawerClose={handleDrawerClose}
            person={person}
            openNewOpenFinanceModal={props.onClick}
          />
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default DelendPaginator;
